import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Pool } from '../models/pool';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PoolDataService {

  constructor(private http: HttpClient) { }

  getAllPools = (projectId: number) :  Observable<Pool[]> => {
    return this.http.get<Pool[]>(`${environment.api.baseUrl}/${environment.api.endpoints.pool.poolList}?projectId=${projectId}`);
  }

  getPool = (poolId: number, projectId: number): Promise<Pool> => {
    return this.http.get<Pool>(`${environment.api.baseUrl}/${environment.api.endpoints.pool.poolList}/${poolId}?projectId=${projectId}`).toPromise();
  }

  createPool = (pool: Pool, projectId: number) => {
    return this.http.post(`${environment.api.baseUrl}/${environment.api.endpoints.pool.poolList}?projectId=${projectId}`, pool).toPromise();
  }

  updatePool = (pool: Pool, projectId: number) => {
    return this.http.post(`${environment.api.baseUrl}/${environment.api.endpoints.pool.poolList}/${pool.id}?projectId=${projectId}`, pool).toPromise();
  }
  
  deletePool = (poolId: number, projectId: number) => {
    return this.http.delete(`${environment.api.baseUrl}/${environment.api.endpoints.pool.poolList}/${poolId}?projectId=${projectId}`).toPromise();
  }

}



